module.exports = __webpack_public_path__ + "img/MO.f1261375.svg";